import { getImage } from 'gatsby-plugin-image'
import React from 'react'

import Parallax from '../../helpers/parallax'
import { FeaturedTag, LeadingParagraph } from '../../pages/whats-on'
import {
  ContentWrapper,
  ExtraMeta,
  H1Styled,
  HeroImage,
  StyledMetaInformation,
  StyledMetaInformationContainer,
} from '../atoms/style-helpers'
import {
  BackgroundFill,
  MetaSection,
  StyledArrowLink,
} from '../organisms/heroCarousel'

type FeaturedPageHeaderProps = {
  page: Queries.ContentfulPage
  categorySlug: string
  pageCategoryParent: {
    title: string
    slug: string
    colour: string
  }
}

const FeaturedPageHeader = (props: FeaturedPageHeaderProps): JSX.Element => {
  const { title, leadingParagraph, slug, heroImage, imageWithFocalPoint } =
    props.page
  const categorySlug = props.categorySlug
    ? `${props.pageCategoryParent ? `${props.pageCategoryParent.slug}/${props.categorySlug}` : props.categorySlug}`
    : null
  const computedSlug = categorySlug ? `${categorySlug}/${slug}` : slug
  const imageData =
    (imageWithFocalPoint && getImage(imageWithFocalPoint?.image)) ||
    (heroImage && getImage(heroImage))
  return (
    <>
      <HeroImage>
        <Parallax image={imageData} />
      </HeroImage>
      <ContentWrapper>
        <ExtraMeta>
          <BackgroundFill>
            <StyledMetaInformationContainer>
              <StyledMetaInformation fullWidth>
                <FeaturedTag>Featured</FeaturedTag>
                <MetaSection>
                  <H1Styled>{title}</H1Styled>
                </MetaSection>
                <MetaSection>
                  <LeadingParagraph>
                    {leadingParagraph?.childMarkdownRemark?.rawMarkdownBody}
                  </LeadingParagraph>
                  <StyledArrowLink to={`/${computedSlug}/`}>
                    <span>Learn more</span>
                  </StyledArrowLink>
                </MetaSection>
              </StyledMetaInformation>
            </StyledMetaInformationContainer>
          </BackgroundFill>
        </ExtraMeta>
      </ContentWrapper>
    </>
  )
}

export default FeaturedPageHeader
